module.exports = __webpack_public_path__ + "static/612-d3102fe39723634b3d82fc09f7d88bcd.png";